'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$43() {
  this.aYM = null;
  this.aYK = null;
  this.aYL = false;
  this.aYI = null;
  this.aYJ = false;
  this.aYN = false;
  this.aYO = false;
  this.aYM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_GroupsView$$anon$43 as $c_Lpresto_GroupsView$$anon$43 };
$p = $c_Lpresto_GroupsView$$anon$43.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$43;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$43() {
}
export { $h_Lpresto_GroupsView$$anon$43 as $h_Lpresto_GroupsView$$anon$43 };
$h_Lpresto_GroupsView$$anon$43.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aYM;
});
$p.t = (function() {
  if ((!this.aYL)) {
    this.aYK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("doctype", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aYL = true;
  }
  return this.aYK;
});
$p.ae = (function() {
  if ((!this.aYJ)) {
    this.aYI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().adw()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aYJ = true;
  }
  return this.aYI;
});
$p.w = (function() {
  if ((!this.aYO)) {
    this.aYN = false;
    this.aYO = true;
  }
  return this.aYN;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_GroupsView$$anon$43 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$43, "presto.GroupsView$$anon$43", ({
  JX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$43 as $d_Lpresto_GroupsView$$anon$43 };
//# sourceMappingURL=presto.-Groups-View$$anon$43.js.map
